import Attributes from "../../../attribute/Attributes.js";
function getExportFormatterTypeForType(type) {
  return `attr.exportFormatter.${type}`;
}
function getAttributeForField(field) {
  const {
    attrName,
    objectType
  } = field;
  return Attributes.getAttribute(attrName, objectType);
}
export default {
  getExportFormatterTypeForType,
  getAttributeForField
};